(function() {
    "use strict";

    const bootstrap = require('bootstrap');
    // TODO: Finish and reactivate the chat
    //const ChatViewModel = require('./chatViewModel');

    class AppViewModel {
        constructor(viewModel, isLoggedIn) {
            this.context = viewModel;
            /*this.chat = null;

            if (isLoggedIn) {
                this.chat = new ChatViewModel();
                this.chat.load();
            }*/

            if (this.context) {
                if (Object.getPrototypeOf(this.context).hasOwnProperty('load')) {
                    this.context.load();
                }
            } else {
                this.context = {};
            }
        }
    }

    module.exports = AppViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/appViewModel.js